import BillBundle from './BillBundle'

import {
  Container,
  Title,
  SubTitle,
  LabelRow
} from './styles'

export default function BillBundleList ({
  bill,
  billBundles = [],
  professionals = [],
  enableEditting = true,
  hasEditPermission = true,
  hasDeletePermission = true,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  return billBundles.length > 0 && (
    <Container>
      <Title>Pacotes</Title>
      <LabelRow enableEditting={enableEditting}>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Profissional</SubTitle>
        <SubTitle>Qtd</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Comissão</SubTitle>
        {enableEditting && <SubTitle>Ações</SubTitle>}
      </LabelRow>
      {billBundles.map ((bundle, index) => (
        <BillBundle
          key={index}
          bill={bill}
          data={bundle}
          professionals={professionals}
          enableEditting={enableEditting}
          hasEditPermission={hasEditPermission}
          hasDeletePermission={hasDeletePermission}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </Container>
  )
}
